import React, { useState, useEffect } from 'react';
import logo from '../blueclan-logo.png';
import './Navbar.css';

const navLinks = [
  { label: 'Home',     href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'About',    href: '#about' },
  { label: 'Product',  href: '#product' },
  { label: 'Team',     href: '#team' },
  { label: 'Contact',  href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState('home');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href) => {
    setMenuOpen(false);
    setActive(href.replace('#', ''));
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container navbar-inner">
        {/* Logo */}
        <a href="#home" className="navbar-logo" onClick={() => handleNav('#home')}>
          <img src={logo} alt="BlueClan Logo" className="logo-img" />
          <div className="logo-text">
            <span className="logo-main">BLUE<span className="logo-accent">CLAN</span></span>
            <span className="logo-sub">ELITE TECHNOLOGY</span>
          </div>
        </a>

        {/* Desktop Links */}
        <ul className="navbar-links">
          {navLinks.map(link => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`nav-link ${active === link.href.replace('#','') ? 'active' : ''}`}
                onClick={() => handleNav(link.href)}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <a href="#contact" className="navbar-cta btn-primary" onClick={() => handleNav('#contact')}>
          <span>Join The Clan</span>
        </a>

        {/* Hamburger */}
        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(p => !p)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <ul>
          {navLinks.map(link => (
            <li key={link.href}>
              <a href={link.href} className="mobile-link" onClick={() => handleNav(link.href)}>
                <span className="mobile-link-num">0{navLinks.indexOf(link)+1}</span>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
        <a href="#contact" className="btn-primary" style={{marginTop:'24px',display:'inline-flex'}} onClick={() => handleNav('#contact')}>
          <span>Join The Clan</span>
        </a>
      </div>
    </nav>
  );
}
